import { TypePermissionEntity } from "@/data/default/types/enumPermission";
import { RouteConfig } from "vue-router";
import RouterDirector from "@/data/default/types/RouterDirector";

const builder = RouterDirector.makeRouterWithPermission({
  name: "tipoOcorrencia",
  permissionEntity: TypePermissionEntity.TIPO_OCORRENCIA,
  componentRoot: () => import("@/screens/default/tipoOcorrencia/Index.vue"),
  componentList: () => import("@/screens/default/tipoOcorrencia/List.vue"),
  componentSave: () => import("@/screens/default/tipoOcorrencia/Save.vue")
});

export const Router: RouteConfig[] = [builder.getRootRoute()];

export const routes = builder.getRouteNames();
